import { PageSection } from '@components/PageSection/PageSection';
import { useCurrentProject } from '@modules/projects/utils/useCurrentProject';
import { ProjectTaskQuery, useProjectTasksQuery } from 'gql/index';
import React from 'react';
import { useIntl } from 'react-intl';
import { TasksTable } from '../TasksTable';

interface Props {
  task: NonNullable<ProjectTaskQuery['projectTask']>;
}

export const TaskPredecessorsSection: React.FC<Props> = ({ task }) => {
  const { formatMessage } = useIntl();
  const { canManageTasks } = useCurrentProject();
  const { data, isFetching } = useProjectTasksQuery({
    projectId: task.projectId, filter: {
      id: {
        in: task.predecessors.map((p) => p.id),
      },
    }
  });

  return (
    <PageSection
      title={formatMessage({ id: 'Predecessors' })}

    >
      <TasksTable
        tasks={data?.projectTasks ?? []}
        loading={isFetching}
        flex={false}
        noDataMessage={!canManageTasks ?
          formatMessage({ id: 'No predecessors found. There may be predecessors that you do not have access to.' }) :
          formatMessage({ id: 'No predecessors.' })}
      />
    </PageSection>
  );
};